import { Injectable } from '@angular/core';
import { UtilService } from '../util/util.service';
import { REACTEVENTS } from 'src/app/react-events';
import { OrderSidenavStateService } from '../common/services/reactOrder.service';
import { AudioService } from '../common/services/audio.service';

declare function send_data(params: string): any;

@Injectable({
  providedIn: 'root',
})
export class OrderReactEventService {
  private autoAcceptOrder = {
    enabled: 0,
    schEnabled: 0,
    applicableOrderType: [],
    schApplicableOrderType: [],
  };

  public prepaidOrder = {
    enabled: false,
    applicableOrderType: [],
  };

  get autoAcceptNotification() {
    return !!((JSON.parse(localStorage.getItem('restaurant_settings')) || {})[
      'global'
    ] || {})['ring_notification'];
  }

  get autoAcceptOrderingStatus() {
    return !!this.autoAcceptOrder.enabled;
  }
  get autoAcceptOrderValue() {
    return this.autoAcceptOrder;
  }
  constructor(
    private _util: UtilService,
    private _reactService: OrderSidenavStateService,
    private _audioService: AudioService
  ) {}

  sendCreateOrderReact(order_id) {
    if (this._util.isReactDevice()) {
      try {
        let data = { action: 'order_created', order_id: order_id };
        let x = JSON.stringify(data);
        send_data(x);
      } catch (error) {}
    }
  }
  sendAcceptDeclineOrderReact(
    order_id,
    type = 'order_accepted',
    extraPayload?
  ) {
    const isReactDevice = this._util.isReactDevice();
    const isOrderCreate = type === REACTEVENTS.ORDER_CREATE;
    if (
      isReactDevice &&
      ((isOrderCreate && !this._reactService.hasSentOrderId(order_id)) ||
        !isOrderCreate)
    ) {
      try {
        let data = {
          action: type,
          order_id: order_id,
          ...(extraPayload && { data: extraPayload }),
        };
        let x = JSON.stringify(data);
        send_data(x);
        isOrderCreate && this._reactService.addSentOrderId(order_id);
      } catch (error) {}
    }
  }

  ctaPhone(number) {
    if (this._util.isReactDevice()) {
      try {
        let data = { action: 'dial_call', phone: number };
        let payload = JSON.stringify(data);
        send_data(payload);
      } catch (error) {}
    } else {
      window.location.href = `tel:${number}`;
    }
  }

  updateAutoAcceptValues() {
    this.autoAcceptOrder.enabled = this._util.isAutoAcceptOrderEnabled('order');
    this.autoAcceptOrder.schEnabled =
      this._util.isAutoAcceptOrderEnabled('schOrder');
    if (this.autoAcceptOrder.enabled) {
      this.autoAcceptOrder.applicableOrderType = this._util.getValidOrderTypes(
        this.autoAcceptOrder.enabled
      );
    }
    if (this.autoAcceptOrder.schEnabled) {
      this.autoAcceptOrder.schApplicableOrderType =
        this._util.getValidOrderTypes(this.autoAcceptOrder.schEnabled);
    }
  }

  triggerPrintEventForAutoAccept(msg) {
    if (
      (this.autoAcceptOrder.enabled &&
        this.autoAcceptOrder.applicableOrderType.includes(
          ((msg || {}).data || {}).order_type
        )) ||
      (this.autoAcceptOrder.schEnabled &&
        this.autoAcceptOrder.schApplicableOrderType.includes(
          ((msg || {}).data || {}).order_type
        ))
    ) {
      // If not scheduled order then send print command for react devices
      const order_status = parseInt(((msg || {}).data || {}).order_status);
      if (!(order_status === 11 || order_status === 12))
        try {
          const { itr, order_type, itr_order_by } = msg.data;
          if (
            this.autoAcceptOrder.applicableOrderType.includes(
              ((msg || {}).data || {}).order_type
            ) &&
            (((msg || {}).data || {}).order_by || '').toLowerCase() ===
              'user' &&
            !(
              order_type === 0 &&
              itr > 1 &&
              (itr_order_by === 'MM' || itr_order_by === 'mPOS')
            )
          ) {
            this._util.sendPrintCommand(
              ((msg || {}).data || {}).order_id,
              ((msg || {}).data || {}).itr
            );
          }
        } catch {}
    }
  }

  computePrepaidOrderSetting() {
    try {
      let rest_settings = (JSON.parse(
        localStorage.getItem('restaurant_settings')
      ) || {})['global'];
      rest_settings &&
        (this.prepaidOrder.enabled = !!rest_settings['enable_pre_paid_order']);

      if (this.prepaidOrder.enabled) {
        let prePaidSettings = (rest_settings || {}).pre_paid_order || 2;
        this.prepaidOrder.applicableOrderType =
          this._util.getValidOrderTypes(prePaidSettings);
      }
    } catch {}
  }

  notifySoundForAutoAccept(orderId) {
    if (this._util.isReactDevice()) {
      this.sendAcceptDeclineOrderReact(orderId, REACTEVENTS.AUTOACCEPT_SOUND);
    } else {
      this._audioService.playAudioOnPaymentEvent(true);
    }
  }

  isOrderApplicableForAutoAccept(orderType) {
    return !!(
      this.autoAcceptOrder.enabled &&
      this.autoAcceptOrder.applicableOrderType.includes(orderType)
    );
  }
}
